import React from "react";
import Header from "../components/header"
import { useStaticQuery, graphql, Link, navigate } from "gatsby";
import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import { off } from "process";
import Form from "../components/form"
import Seo from "../components/seo"

export default function About({data}) {


  const [visible, setVisible] = React.useState(false)

  function Toggle(){
    setVisible((prevState)=>!prevState)
  }

    const {title, content} = data.wpPage
    const {firstDescription, secondDescription, lasttitle, subtitle, exportText, firstImage, secondImage} = data.wpPage.aboutUsFields

    React.useEffect(()=>{
      let content = document.getElementById('content')

      function smoothScroll(e){

        content.scrollLeft += (e.deltaY * 0.4)
        
      }


      content.addEventListener('wheel', (e)=>smoothScroll(e))
      

      return () => content.removeEventListener('wheel', (e)=>smoothScroll(e))

    })


    return(
     
        <div className="relative overflow-hidden about-page">
            <Header/>
            <Form visible={visible} setVisible={setVisible} type={"Page"} currentPage={"About Us"}/>
            <div className="flex pt-[80px] h-[100vh] transition-translate duration-100 ease-in-out overflow-x-auto overflow-y-hidden about-page" id="content">
      
                <div className="childOverflow flex flex-col justify-end lg:justify-start relative max-w-[100vw]">
                  <StaticImage src={'../images/about/about-2.png'} className="absolutes absolute top-0 left-0 w-[60vw] sm:w-[40vw] lg:w-[20vw]" placeholder="none"/>
                
                  <div className="flex flex-col items-center pb-16">
                    <h1 className="md:text-9xl xl:text-10xl text-center lg:mt-[5vh] 2xl:text-12xl 2xl:mt-[10vh]">
                      <span className="uppercase text-10xl">About</span>
                      <span className="font-caslon md:text-9xl xl:text-12xl"> us</span>
                    </h1>
                    <StaticImage src={'../images/about/about-1.png'} className="ecuador-map-img hidden sm:hidden md:hidden lg:block lg:ml-[30vw] 3xl:ml-[10vw] lg:max-w-[400px] xl:max-w-[600px] 2xl:max-w-[800px] " placeholder="none"/>
                    <p className="block lg:hidden px-4 md:px-16 md:text-2xl" dangerouslySetInnerHTML={{__html:firstDescription}}></p>
                  </div>

                    <h4 className="hidden lg:text-xl xl:text-2xl lg:block absolute bottom-[10vh] left-[120px] max-w-[40vw] xl:w-[450px] 2xl:w-[550px]" dangerouslySetInnerHTML={{__html:firstDescription}}></h4>
                </div>
                

                <div className="lg:hidden childOverflow -ml-[30vw] pb-[250px] h-full flex justify-center items-center">
                  <StaticImage src={'../images/about/about-1.png'} className="lg:hidden w-[500px]" placeholder="none"/>
                </div>
                
               
                <div className="childOverflow -ml-[140px] lg:-ml-[15vw] xl:-ml-[20vw] w-[800px] max-w-[900px] md:w-[1400px] w-fit h-full md:max-w-[1400px] xl:max-w-[1400px]">
                  <StaticImage src={'../images/about/about-3.png'} className="h-[100%] min-w-[900px] w-[800px] md:w-[1400px] xl:w-auto" placeholder="none"/>
                </div>
                

                <div className="childOverflow relative">
                  <div className="flex items-center h-full lg:mt-[10vh]">
                    <div className="flex gap-12 max-w-[2400px]">
                      <h4 className="text-base lg:3xl w-[90vw] md:w-[50vw] max-w-[600px]" dangerouslySetInnerHTML={{__html:secondDescription}}></h4>
                      <StaticImage src={'../images/about/about-7.jpg'} className="w-[250px] lg:w-[400px] h-[60vh] lg:h-[600px]" placeholder="none"/>
                      <StaticImage src={'../images/about/about-4.jpg'} className="w-[120vw] md:w-[90vw] max-w-[1000px] h-[60vh] lg:h-[600px]" placeholder="none"/>
                    </div>
                  
                  </div>
                </div>


                           
                <div className="childOverflow h-full max-w-[850px] -ml-[30vw]">
                  <StaticImage src={'../images/about/about-5.png'} className="h-[100%] min-w-[450px] max-w-[850px]" placeholder="none"/>
                </div>


                <div className="h-full w-fit min-w-[300px] md:min-w-[500px] lg:min-w-[800px]  max-w-[90vw] flex items-end pb-[15vh] ml-[20px] lg:ml-[200px]">
                  <div className="flex flex-col items-end w-fit">
                    <h5 className="mb-[10vh] lg:mb-[30vh] w-fit" dangerouslySetInnerHTML={{__html:exportText}}></h5>
                    <h6 className="text-base lg:text-2xl w-full w-fit" dangerouslySetInnerHTML={{__html:subtitle}}></h6>
                    <h1 className="text-7xl lg:text-9xl w-fit" dangerouslySetInnerHTML={{__html:lasttitle}}></h1>
                  </div>
                </div>
                {/* -ml-[10vw] md:-ml-[260px] lg:-ml-[200px] xl:-ml-[400px] 2xl:-ml-[60vw]  */}
                <div className="h-full max-w-[800px]">
                  <div className="h-full flex flex-col w-fit justify-around items-end pr-[10vw] lg:pr-[5vw]">
                    <StaticImage src={'../images/about/about-6.png'} className="min-w-[600px] lg:w-[50vw]" placeholder="none"/>
                    
                    <div className="flex gap-8 justify-end">
                      <nav className='flex-1 flex flex-row gap-8 md:gap-14 justify-end items-center'>
                          <Link to="/contact" onTouchEnd={()=>navigate('/contact')} className="text-xl lg:text-xl text-black hover:text-red transition">CONTACT</Link>
                          <button onClick={() => window.open('https://qrco.de/2026RFCatalog')} onTouch={() => window.open('https://qrco.de/2026RFCatalog')}  className='px-2 py-2 md:py-2 md:px-6 h-full border uppercase hover:bg-charcoal hover:text-cream transition-all duration-200 ease-in-out text-xl lg:text-xl cursor-pointer'>See our catalog</button>
                      </nav>
                    </div>
                  </div>
                </div> 


            </div>
           
            

        </div>
    )
  }
    


  export function Head({data}){

    const {wpPage:{seo}} = data
  
    return(
        <Seo
        title={seo.title}
        description={seo.metaDesc}
        url={data.site.siteMetadata.siteUrl + '/about'}
      >    
      </Seo>
    )
  
  }

  export const query = graphql`
      query AboutUs {
        site{
          siteMetadata{
              siteUrl
          }
        }
        wpPage(title: {eq: "About Us"}) {
            title
            slug
            content
              seo{
                  title
                  metaDesc
                  canonical
              }
            aboutUsFields {
              firstDescription
              secondDescription
              lasttitle
              subtitle
              exportText
              
            }
          }
      }
  `